__turbopack_context__.v({
  "divider": "RLdmEG_divider",
  "paymentButtonWrapper": "RLdmEG_paymentButtonWrapper",
  "section": "RLdmEG_section",
  "sectionContent": "RLdmEG_sectionContent",
  "sectionItemLabel": "RLdmEG_sectionItemLabel",
  "sectionItemValue": "RLdmEG_sectionItemValue",
  "sectionItems": "RLdmEG_sectionItems",
  "sectionSingleItem": "RLdmEG_sectionSingleItem",
  "sectionTitle": "RLdmEG_sectionTitle",
  "sectionTitleBar": "RLdmEG_sectionTitleBar",
});
